import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { MainUI } from "./authenticated/MainUI";
import { NonAuthenticatedRoutes } from "./non-authenticated/NonAuthenticatedRoutes";
import { Routes } from "./Routes";
import { REGISTER_REMOVE_AUTHENTICATION_TOKEN } from "src/app/reducers/AppReducer";
import { useAuthenticationTokenResult } from "src/authentication/hooks/useAuthenticationTokenResult";
import { useRemoveAuthenticationToken } from "src/authentication/hooks/useRemoveAuthenticationToken";
import { ReactQueryResult } from "src/shared/components/ReactQueryResult";

export const AppAuthentication = () => {
  const authenticationTokenResult = useAuthenticationTokenResult();

  const removeAuthenticationToken = useRemoveAuthenticationToken();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: REGISTER_REMOVE_AUTHENTICATION_TOKEN,
      removeAuthenticationTokenHandler: removeAuthenticationToken,
    });
  }, [dispatch, removeAuthenticationToken]);

  return (
    <BrowserRouter>
      <ReactQueryResult {...authenticationTokenResult}>
        {(authenticationToken) => {
          return (
            <Routes
              component={authenticationToken ? MainUI : NonAuthenticatedRoutes}
            />
          );
        }}
      </ReactQueryResult>
    </BrowserRouter>
  );
};
